import { KnownCreateAccessControlDtoType } from '@groundfloor-platform/mgmt-service-g-sdk';
import { RJSFSchema } from '@rjsf/utils';

export class AccessControlFormSchema {
  static FromFormData(
    parentEntityId: string | undefined,
    parentDisplayName: string | undefined,
    isEdit = false,
    isDeleted = false
  ): RJSFSchema {
    return {
      properties: {
        attachedToId: {
          type: 'string',
          title: 'To',
          readOnly: true,
          default: parentEntityId,
          ...(parentEntityId && {
            oneOf: [
              {
                type: 'string' as const,
                title: parentDisplayName ?? parentEntityId,
                enum: [parentEntityId]
              }
            ]
          })
        },
        type: {
          type: 'string',
          title: 'Type',
          readOnly: isEdit,
          default: KnownCreateAccessControlDtoType.Code,
          oneOf: [
            {
              type: 'string' as const,
              title: 'Door codes',
              enum: [KnownCreateAccessControlDtoType.Code]
            }
          ]
        },
        instructions: {
          type: 'string',
          title: 'Instructions to courier',
          default: "You'll need this code to get into the front door",
          ...(isDeleted && { readOnly: true })
        },
        codes: {
          type: 'array',
          title: 'Supplied codes',
          items: { type: 'string', minLength: 1 },
          ...(isDeleted && { readOnly: true })
        }
      },
      required: ['type', 'instructions', 'codes']
    };
  }
}
